import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';

import { Account } from '@personal-area/global/accounts/models';

import { AddDemoFundsWidgetComponent } from '../add-demo-funds-widget/add-demo-funds-widget.component';

interface DialogData {
  account: Account;
}

@Component({
    selector: 'app-add-demo-funds-popup',
    templateUrl: './add-demo-funds-popup.component.html',
    styleUrls: ['./add-demo-funds-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogClose, AddDemoFundsWidgetComponent]
})
export class AddDemoFundsPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _dialogRef: MatDialogRef<AddDemoFundsPopupComponent>,
  ) {}

  public onSuccess(amount: number) {
    this._dialogRef.close({ amount: amount });
  }

  public onError(err: HttpErrorResponse) {
    this._dialogRef.close({ error: err });
  }
}
